// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';

const _ = require('lodash');

// Components
import PopularContent from 'src/components/home-page/popular/popular-content';
import HomePageNavBar from 'components/home-page/nav-bar/home-page-nav-bar';
import HomePageHelper from 'components/home-page/home-page-helper';
import { HomepageSkeleton } from 'components/SharedComponents/loading-state/homepage-skeleton';
import { HomepageBanner } from 'components/home-page/banner/homepage-banner';
import { WebinarRedirectModal } from 'components/SharedComponents/modal/webinar-redirect-modal';
import * as cookieHelper from 'src/app-lib/helpers/CookieHelper';
import * as genericHelper from 'src/app-lib/helpers/genericHelper';

// Redux
import * as recommendationActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/recommendations';
import * as authInfoActions from '@getgo/webinar.com-frontend-redux/lib/web/actions/auth-info';
import * as contentsActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/contents';
import * as identityActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/identity-info';
import * as channelActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/channel-profile';
import * as headerActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as attendeeActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/attendee-info';

import * as homePageActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/home-page';

// Helpers
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import * as categories from 'components/SharedComponents/categories';

const homePageHelper = new HomePageHelper();
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';
import * as sessionStorageHelper from 'app-lib/helpers/SessionStorageHelper';


export class HomePage extends React.Component {
// ------------------------------------------------------------------ LIFECYCLE METHODS ------------------------------------------------------------------

    constructor(props) {
        super(props);
        this.state = {
            currentCategory: homePageHelper.defaultCategory,
            showSkeleton: true,
            webinarRedirectModalShown: !!(genericHelper.getUrlQueryParameter('joinType') && !sessionStorageHelper.getSessionStorageKey('webinarRedirectModalShown'))
        };
    }

    componentDidMount() {
        this.componentMountActions();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.recommendations && !_.isEqual(nextProps.recommendations, this.props.recommendations)) {
            this.props.updateShowSkeleton(false);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.recommendations && this.props.recommendations.popular && !_.isEqual(prevProps.recommendations.popular, this.props.recommendations.popular)) {
            // update the categories
            homePageHelper.popularCategories = categories.homePageCategoriesArray;
        }
        if (this.props.identity && !_.isEqual(prevProps.identity.channelInfo, this.props.identity.channelInfo)) {
            this.reportHomepageVisit();
        }
    }

    componentWillUnmount() {
        this.props.initHeader();
    }

    setHeader() {
        if (!this.props.isUserLoggedIn) {
            this.props.initHeader({isActive: false});
            return;
        }
        this.props.initHeader({
            navbarBackgroundClasses: 'homepage--nav-background',
            menuItemTextClasses: 'homepage-header-menu-item-text',
            showAlternateLogo: true,
            showSearch: true
        });
    }


    reportHomepageVisit() {
        if (this.props.identity.channelInfo.isFetching > 0) {
            return;
        }
        const superProperties = {};
        superProperties.channelKey = this.props.myChannelKey;
        mixpanelTracker.setSuperProperties(superProperties);
        if (genericHelper.getUrlQueryParameter('joinType')) {
            PageTracker.lastPage = Page.WEBINAR_REDIRECT;
        }
        mixpanelTracker.reportHomepageVisit(PageTracker.lastPage);
        PageTracker.lastPage = Page.HOMEPAGE;
    }


    scrollToYPosition() {
        if (!this.props.homePageState.showSkeleton) {
            window.scrollTo(0, this.props.homePageState.scrollPositionY);
        }
    }

    setWebinarAttendeeInfo() {
        const {attendeeInfo} = this.props;
        if (attendeeInfo && attendeeInfo.webinarAttendeeInfo && !Object.keys(attendeeInfo.webinarAttendeeInfo).length) {
            const webinarAttendeeInfo = genericHelper.getWebinarAttendeeInfo('joinMeta');
            webinarAttendeeInfo ? this.props.setWebinarAttendeeInfo(webinarAttendeeInfo) : null;
        }
    }

    componentMountActions() {
        this.setHeader();
        if (!this.props.recommendations.popular) {
            genericHelper.getUrlQueryParameter('joinMeta') ?
                this.getRecommendations(undefined, undefined, undefined, undefined, genericHelper.getUrlQueryParameter('joinMeta')) : this.getRecommendations();
        }
        this.reportHomepageVisit();
        this.scrollToYPosition();
        this.setWebinarAttendeeInfo();
    }

    // ------------------------------------------------------------------ HELPER METHODS ------------------------------------------------------------------
    categoryChanged(currentCategory) {
        this.props.updateCurrentCategory(currentCategory);
        if (!Object.keys(this.props.recommendations.popular.categories).includes(currentCategory)) {
            // when category is changed always get the page number 0 for that category
            this.getRecommendations('POPULAR', currentCategory);
        }
    }

    getRecommendations(type = 'POPULAR', category = 'ANY', pageNumber = 0, pageSize = 20, referrerMetadata) {
        const g2sAnonymousId = cookieHelper.getG2sAnonymousIdCookie();
        this.props.getRecommendationsPaginated(type, category, pageNumber, pageSize, g2sAnonymousId, referrerMetadata);
    }

    getContentMetaDataForRecommendations(keys) {
        this.props.getRecommendedContentMetaData(keys);
    }

    getRecommendedContentsChannelInfo(keys) {
        this.props.getRecommendedContentsChannelMetaData(keys);
    }
    // ------------------------------------------------------------------ RENDERING METHODS ------------------------------------------------------------------


    createNavBar() {
        if (this.props.recommendations && this.props.recommendations.popular) {
            return (
                <HomePageNavBar
                  navCategories={categories.homePageCategoriesArray}
                  currentCategory={this.props.homePageState.currentCategory}
                  categoryChanged={(category) => { this.categoryChanged(category); }}
                />
            );
        }
        return null;
    }

    checkAndDisplayPopularRecommendations() {
        if (this.props.recommendations && this.props.recommendations.popular) {
            const popularRec = this.props.recommendations.popular;
            if ((Object.keys(popularRec).length > 0) && popularRec.constructor === Object) {
                homePageHelper.popularCategories = categories.homePageCategoriesArray;
                return (
                    <PopularContent
                      currentCategory={this.props.homePageState.currentCategory}
                      currentPageNumberMap={this.props.currentPageNumberForCategories}
                      lastPageNumberMap={this.props.lastPageNumbersForCategories}
                      popularContents={popularRec}
                      contentMetaData={this.props.contentMetaData}
                      getContents={this.getContentMetaDataForRecommendations.bind(this)}
                      getContentsChannel={this.getRecommendedContentsChannelInfo.bind(this)}
                      loadMore={this.getRecommendations.bind(this)}
                    />
                );
            }
        }

        return null;
    }

    homepageBanner() {
        if (this.props.isUserLoggedIn) {
            return null;
        }
        const homepageBannerProps = {
            t: this.props.t,
            showSearchInputOverlay: this.props.showSearchInputOverlay,
            showSearch: this.props.launchDarkly.search.enableSearch
        };
        return (<HomepageBanner {...homepageBannerProps} />);
    }

    showContents() {
        return (
            this.props.homePageState.showSkeleton ? <HomepageSkeleton /> : this.checkAndDisplayPopularRecommendations()
        );
    }

    showWebinarRedirectModal() {
        return this.state.webinarRedirectModalShown && <WebinarRedirectModal t={this.props.t} />;
    }

    render() {
        return (
            <div>
                {this.homepageBanner()}
                {this.createNavBar()}
                {this.showContents()}
                {this.showWebinarRedirectModal()}
            </div>
        );
    }
}

HomePage.propTypes = {
    isUserLoggedIn: PropTypes.bool,
    isOrganizer: PropTypes.bool,
    myChannelKey: PropTypes.string,
    auth: PropTypes.object,
    identity: PropTypes.object,
    launchDarkly: PropTypes.object,
    t: PropTypes.func,
    contentMetaData: PropTypes.object,
    getRecommendations: PropTypes.func,
    getRecommendationsPaginated: PropTypes.func,
    recommendations: PropTypes.object,
    isFetchingRecommendations: PropTypes.number,
    getRecommendedContentMetaData: PropTypes.func,
    getRecommendedContentsChannelMetaData: PropTypes.func,
    logout: PropTypes.func,
    popularContents: PropTypes.object,
    homePageState: PropTypes.object,
    updateCurrentCategory: PropTypes.func,
    updateShowSkeleton: PropTypes.func,
    initHeader: PropTypes.func,
    showSearchInputOverlay: PropTypes.func,
    lastPageNumbersForCategories: PropTypes.object,
    currentPageNumberForCategories: PropTypes.object,
    attendeeInfo: PropTypes.object,
    setWebinarAttendeeInfo: PropTypes.func
};

export default connect(
    state => ({
        recommendations: (state.recommendations && state.recommendations.recommendations) ? state.recommendations.recommendations : null,
        contentMetaData: (state.recommendations && state.recommendations.contentMetaData) ? state.recommendations.contentMetaData : null,
        isFetchingRecommendations: (state.recommendations.isFetching) ? state.recommendations.isFetching : 0,
        recommendation: state.recommendations,
        currentPageNumberForCategories: (state.recommendations && state.recommendations.currentPageNumberForCategories) ? state.recommendations.currentPageNumberForCategories : null,
        lastPageNumbersForCategories: (state.recommendations && state.recommendations.lastPageNumbersForCategories) ? state.recommendations.lastPageNumbersForCategories : null,
        channel: state.channel,
        homePageState: state.homePage,
        identity: state.identity,
        attendeeInfo: state.attendeeInfo
    }),
    dispatch => bindActionCreators(Object.assign({}, recommendationActions, authInfoActions, channelActions, contentsActions, identityActions, homePageActions, headerActions,
        attendeeActions), dispatch))(translate(['translation'])(HomePage));



// WEBPACK FOOTER //
// ./src/components/home-page/homePage.js